import { Middleware } from '@nuxt/types'
import { isSitecoreRequest } from '~/utils/isSitecoreRequest'
import { getOptions } from '~/utils/getOptions'
import isEmptyObject from '~/helpers/is-empty-object'

const featureFlagging: Middleware = async ({ app, req, store, route, error }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const flags = getOptions(route, 'features')

  if (!flags.length) {
    return
  }

  const hasToken = !!store.state.oauth.accessToken

  // The page has flags, needs to be an authenticated user
  if (!hasToken) {
    // This will cause a redirect loop for public users if you add feature flags to the index page
    // Don't do that
    return error({ statusCode: 404 })
  }

  const isFeatureEnabled = store.getters['user/account/isFeatureEnabled']

  if (flags.every((flag: string) => isFeatureEnabled(flag))) {
    return
  }

  error({ statusCode: 404 })
}

export default featureFlagging
